import { useState } from "react";
import { Box, ButtonBase, Grid, IconButton } from "@mui/material";
import {
  KeyboardArrowRight,
  ChevronLeft,
  ChevronRight,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import CustomText from "../components/CustomText";
import CustomButton from "../components/CustomButton";
import ImageLoader from "../components/ImageLoader";

const TypesOfService = () => {
  const navigate = useNavigate();

  const [selected, setSelected] = useState(ServiceItem[0]);
  const [currentImage, setCurrentImage] = useState(0);
  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  /*
   * Todas las imágenes de la galería
   */
  const galleryImages = [
    selected.gallery.leftTop,
    selected.gallery.leftBottom,
    selected.gallery.rightTop,
    selected.gallery.rightBottom,
  ];

  /*
   * Cuando cambia el servicio,
   * regresamos el carrusel a la primera imagen.
   */
  const handleServiceChange = (item) => {
    setSelected(item);
    setCurrentImage(0);
  };

  /*
   * Imagen anterior
   */
  const previousImage = () => {
    setCurrentImage((prev) =>
      prev === 0 ? galleryImages.length - 1 : prev - 1,
    );
  };

  /*
   * Imagen siguiente
   */
  const nextImage = () => {
    setCurrentImage((prev) =>
      prev === galleryImages.length - 1 ? 0 : prev + 1,
    );
  };

  /*
   * Detectar inicio del swipe
   */
  const handleTouchStart = (e) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  /*
   * Detectar movimiento
   */
  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };
  /*
   * Detectar final del swipe
   */
  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) return;

    const distance = touchStart - touchEnd;
    /*
     * 50px es la distancia mínima
     * para considerar que fue un swipe.
     */
    const minSwipeDistance = 50;
    if (distance > minSwipeDistance) {
      // Deslizó hacia la izquierda
      nextImage();
    }
    if (distance < -minSwipeDistance) {
      // Deslizó hacia la derecha
      previousImage();
    }
  };

  return (
    <Grid container sx={design.Container}>
      <CustomText variant="subtitle1" color="#162E84" sx={design.Title}>
        Cuida de tu salud y la de tu familia
      </CustomText>
      <Grid container justifyContent="center" sx={design.Content}>
        <Box sx={design.TabsContainer}>
          {ServiceItem.map((item) => {
            const active = selected.name === item.name;
            return (
              <Box key={item.name} sx={design.BoxBoton}>
                <ButtonBase
                  onClick={() => handleServiceChange(item)}
                  sx={design.ButtonB(active, item)}
                >
                  {item.name}
                  {active && (
                    <>
                      <Box className="bridge" display={design.Bridge} />
                      <Box sx={design.CurvaIzq} />
                      <Box sx={design.CurvaDer} />
                    </>
                  )}
                </ButtonBase>
              </Box>
            );
          })}
        </Box>
        {/* CARD PRINCIPAL */}
        <Grid container sx={design.CardColor(selected)}>
          <Grid container sx={design.Img}>
            <Grid item size={design.GridImage} sx={design.Align}>
              <ImageLoader
                src={selected.image}
                alt={selected.title}
                width={{ xs: "97%", md: "93%" }}
                height={{ xs: "97%", md: "93%" }}
                borderRadius={{ xs: 5, md: 10 }}
                objectPosition="30% center"
              />
            </Grid>
            <Grid item size={design.GridText} sx={design.AlignText}>
              <CustomText color="#FFF" sx={design.CardTitle}>
                {selected.title}
              </CustomText>
              <CustomText color="#FFF" sx={design.CardDescription}>
                {selected.descripCard}
              </CustomText>
              <CustomText color="#FFF" sx={design.CardDescription}>
                {selected.description}
              </CustomText>
              <CustomButton
                variant="contained"
                backgroundColor="#FFFFFF"
                colorTexto={selected.color}
                width={{ xs: "100%", md: "50%" }}
                height={{ xs: 200, md: 50 }}
                borderRadius={14}
                align={true}
                style={design.Buttom}
                onClick={() =>
                  navigate(
                    `/servicios?name=${encodeURIComponent(selected.name)}`,
                  )
                }
              >
                Conocer más
                <KeyboardArrowRight />
              </CustomButton>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container sx={design.AlignImg}>
        {/* =========================TELÉFONO======================== */}
        <Box
          sx={design.MobileCarousel}
          onTouchStart={handleTouchStart}
          onTouchMove={handleTouchMove}
          onTouchEnd={handleTouchEnd}
        >
          {/* IMAGEN ACTUAL */}
          <Box sx={design.MobileSlide}>
            <ImageLoader
              src={galleryImages[currentImage].src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={galleryImages[currentImage].objectPosition}
            />
            {/* FLECHA IZQUIERDA */}
            <IconButton onClick={previousImage} sx={design.ArrowLeft}>
              <ChevronLeft />
            </IconButton>
            {/* FLECHA DERECHA */}
            <IconButton onClick={nextImage} sx={design.ArrowRight}>
              <ChevronRight />
            </IconButton>
          </Box>
          {/* INDICADORES */}
          <Box sx={design.Dots}>
            {galleryImages.map((_, index) => (
              <Box
                key={index}
                onClick={() => setCurrentImage(index)}
                sx={design.Dot(index === currentImage, selected.color)}
              />
            ))}
          </Box>
        </Box>
        {/* ======================DESKTOP=========================== */}
        {/* Columna izquierda */}
        <Grid size={design.Grid6} sx={design.GridS}>
          <Box sx={design.TamImgIzq}>
            <ImageLoader
              src={selected.gallery.leftTop.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.leftTop.objectPosition}
            />
          </Box>
          <Box sx={design.TamImgDer}>
            <ImageLoader
              src={selected.gallery.leftBottom.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.leftBottom.objectPosition}
            />
          </Box>
        </Grid>
        {/* Columna derecha */}
        <Grid size={design.Grid6} sx={design.GridPosit}>
          <Box sx={design.TamRigth}>
            <ImageLoader
              src={selected.gallery.rightTop.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.rightTop.objectPosition}
            />
          </Box>
          <Box sx={design.TamLeft}>
            <ImageLoader
              src={selected.gallery.rightBottom.src}
              width="100%"
              height="100%"
              borderRadius={5}
              objectPosition={selected.gallery.rightBottom.objectPosition}
            />
          </Box>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TypesOfService;

const design = {
  Container: {
    width: "100%",
    flexDirection: { xs: "none", md: "column" },
    alignItems: "center",
    justifyContent: "center",
    py: { xs: 2, md: 8 },
    px: { xs: 2, md: 2 },
  },
  Bridge: {
    xs: "none",
    md: "block",
  },
  Content: {
    width: "100%",
    mt: { xs: 1, md: 5 },
    flexDirection: "column",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  Title: {
    fontFamily: "Nunito",
    fontWeight: 800,
    textAlign: "center",
    lineHeight: 1.2,
    mb: 2,
    fontSize: { xs: 26, sm: 34, md: 42, lg: 48 },
  },
  BoxBoton: {
    flexDirection: "column",
    display: "flex",
  },
  TabsContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-end",
    flexWrap: "wrap",
    gap: 3,
    position: "relative",
    zIndex: 5,
    mb: { xs: "10px", md: "10px" },
  },
  GridImage: { xs: 12, md: 6 },
  GridText: { xs: 12, md: 6 },
  CardTitle: {
    fontFamily: "Nunito",
    fontWeight: "bold",
    textAlign: "center",
    mt: 2,
    fontSize: { xs: 28, md: 38 },
  },
  CardDescription: {
    fontFamily: "Nunito",
    textAlign: "justify",
    mb: 2,
    fontSize: { xs: 15, md: 19 },
  },
  ButtonB: (active, item) => ({
    position: "relative",
    overflow: "visible",
    minWidth: 155,
    height: 40,
    px: { xs: 1, md: 3 },
    border: "2px solid",
    borderRadius: "10px",
    fontFamily: "Nunito",
    fontWeight: 700,
    fontSize: 15,
    backgroundColor: active ? item.color : "#fff",
    color: active ? "#fff" : item.color,
    borderColor: item.color,
    "& .bridge": active
      ? {
          position: "absolute",
          left: -12,
          right: -2,
          bottom: -39,
          height: 44,
          width: "115%",
          background: item.color,
        }
      : {},
  }),
  CurvaIzq: {
    position: "absolute",
    width: 20,
    height: 35,
    left: { xs: -22, sm: -22, md: -22, lg: -22, xl: -22 },
    bottom: { xs: -23, sm: -23, md: -22, lg: -23, xl: -22.5 },
    borderBottomRightRadius: 10,
    background: "#fFF",
    zIndex: 0,
  },
  CurvaDer: {
    position: "absolute",
    width: 20,
    height: 35,
    right: -22,
    bottom: -23,
    borderBottomLeftRadius: 10,
    background: "#fFF",
  },
  CardColor: (selected) => ({
    spacing: 4,
    marginTop: 1.35,
    width: "100%",
    maxWidth: 1100,
    minHeight: { xs: "auto", sm: 520, md: 500 },
    height: "auto",
    borderRadius: 6,
    background: `linear-gradient( 180deg, ${selected.color} 70%, #FFF 100%)`,
    zIndex: 5,
  }),
  Img: {
    position: "relative",
    minHeight: { xs: "auto", md: 490 },
    maxHeight: { xs: "auto", md: 490 },
    overflow: "hidden",
    "&::before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundImage:
        "url('https://centromedicomedam.com/IMG/centromedicoMEDAM/GreyRapport.svg')",
      backgroundRepeat: "repeat",
      backgroundSize: "150%",
      opacity: 0.3,
      pointerEvents: "none",
    },
    paddingBottom: { xs: 5, md: 0 },
  },
  Align: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  AlignText: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    pr: { xs: 2, md: 5 },
    pl: { xs: 2, md: 0 },
  },
  Buttom: {
    marginTop: { xs: 1, md: 10 },
    marginBottom: { xs: 10, md: 0 },
    fontFamily: "Nunito",
    fontWeight: "bold",
  },
  AlignImg: {
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    mt: 3,
  },
  MobileCarousel: {
    display: { xs: "block", sm: "none" },
    width: "100%",
    maxWidth: 500,
    position: "relative",
    px: 1,
    touchAction: "pan-y",
  },
  MobileSlide: {
    position: "relative",
    width: "100%",
    height: { xs: 280 },
    borderRadius: 5,
    overflow: "hidden",
  },
  ArrowLeft: {
    position: "absolute",
    left: 10,
    top: "50%",
    transform: "translateY(-50%)",
    width: 40,
    height: 40,
    backgroundColor: "rgba(255,255,255,0.85)",
    color: "#162E84",
    zIndex: 10,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.95)",
    },
  },
  ArrowRight: {
    position: "absolute",
    right: 10,
    top: "50%",
    transform: "translateY(-50%)",
    width: 40,
    height: 40,
    backgroundColor: "rgba(255,255,255,0.85)",
    color: "#162E84",
    zIndex: 10,
    "&:hover": {
      backgroundColor: "rgba(255,255,255,0.95)",
    },
  },
  Dots: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 1,
    mt: 1,
  },
  Dot: (active, color) => ({
    width: active ? 22 : 8,
    height: 8,
    borderRadius: 10,
    backgroundColor: active ? color : "#D0D0D0",
    cursor: "pointer",
    transition: "all 0.3s ease",
  }),
  GridS: {
    display: { xs: "none", sm: "flex" },
    flexDirection: "column",
    gap: 3,
  },
  Grid6: { xs: 12, md: 6, xl: 6, lg: 6 },
  TamImgIzq: {
    width: 350,
    height: 507,
  },
  TamImgDer: {
    width: 509,
    height: 285,
  },
  GridPosit: {
    display: { xs: "none", sm: "flex" },
    flexDirection: "column",
    alignItems: "flex-end",
    gap: 3,
    ml: -7,
  },
  TamRigth: {
    width: 551,
    height: 379,
  },
  TamLeft: {
    width: 415,
    height: 415,
  },
};

const ServiceItem = [
  {
    name: "Torre medica",
    color: "#782A9F",
    title: "Torre Médica",
    descripCard:
      "En nuestra Torre Médica, combinamos tecnología de vanguardia con un equipo de especialistas comprometidos con tu bienestar.",
    description:
      "Aquí recibirás una atención personalizada y profesional, diseñada para atender tus necesidades de salud con excelencia y cercanía.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Torre_Medica_del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_ginecologico_vertical.png",
        objectPosition: "75% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_Ginecologico.png",
        objectPosition: "1% center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Puertas_Consultorios.png",
        objectPosition: "1% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Consultorio_privada.png",
        objectPosition: "center",
      },
    },
  },
  {
    name: "Hospitalización",
    color: "#489E4D",
    title: "Hospitalización",
    descripCard:
      "En nuestra área de hospitalización, cuidamos de ti con la misma dedicación con la que lo haríamos por alguien de nuestra familia.",
    description:
      "Contamos con un entorno seguro, tranquilo y confortable, donde nuestro equipo médico y de enfermería trabaja con empatía, profesionalismo y atención personalizada para acompañarte en cada etapa de tu recuperación.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Hospitalizacion_detalles_del_centro-medico_MEDAM.png",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Entradahabitacion.png",
        objectPosition: "55% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion.png",
        objectPosition: "center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_principal_medam.png",
        objectPosition: "75% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_Basica.png",
        objectPosition: "75% center",
      },
    },
  },
  {
    name: "Urgencias",
    color: "#D32D2D",
    title: "Urgencias",
    descripCard:
      "En nuestra área de Urgencias, estamos disponibles las 24 horas del día con un equipo médico preparado para atenderte en los momentos más críticos.",
    description:
      "Contamos con personal capacitado y equipamiento adecuado para resolver la mayoría de las situaciones urgentes de forma rápida, segura y con trato humano. Porque cuando se trata de tu salud, cada minuto cuenta.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Urgencias_detalles__del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Quirofano_Horizontal_medam.png",
        objectPosition: "10% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Sala_Recuperacon_MEDAM.png",
        objectPosition: "center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Habitacion_recuperacion_MEDAM.png",
        objectPosition: "center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/Quirofano_Vertical_MEDAM.png",
        objectPosition: "45% center",
      },
    },
  },
  {
    name: "Laboratorio Clínico",
    color: "#215DA6",
    title: "Laboratorio Clínico",
    descripCard:
      "Nuestro laboratorio clínico es el punto de partida para un diagnóstico confiable. Con tecnología de punta y personal capacitado, garantizamos resultados precisos para que cada paso de tu tratamiento esté respaldado por el profesionalismo que mereces.",
    description:
      "Es por eso que, para cumplir con ese objetivo, nos aliamos con Laboratorio Clínico Durán, uno de los laboratorios más prestigiosos, reconocido por su excelencia y compromiso con la salud.",
    image:
      "https://centromedicomedam.com/IMG/centromedicoMEDAM/Laboratorio_Clinico_del_centro-medico_MEDAM.jpg",
    gallery: {
      leftTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/habitacion_consulta.png",
        objectPosition: "75% center",
      },
      leftBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/tomografo_Medam.png",
        objectPosition: "75% center",
      },
      rightTop: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/pared_Mastografia.png",
        objectPosition: "75% center",
      },
      rightBottom: {
        src: "https://centromedicomedam.com/IMG/centromedicoMEDAM/habitacion_de_exploracion.png",
        objectPosition: "75% center",
      },
    },
  },
];
